module.exports = __webpack_public_path__ + "static/media/oberflex-acajouafriquet19-1200x2490.a9a188d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-acajouafriquet19-1200x2490.jpg
// module id = 964
// module chunks = 37